import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import FavouriteBtn from '../../atoms/FavouriteBtn/FavouriteBtn';
import LazyPicture from '../../atoms/LazyPicture';
import RouterLink from '../../atoms/RouterLink';
import Reminder from '../../atoms/Reminder/Reminder';
import CuratorPicks from '../../atoms/CuratorPicks/CuratorPicks';
import { convertDate } from '../Events';
import { pathJoin, getMediaHost, injectImageResolution, get, getListingItemURL } from '../../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
import { BlurCard, EBlurCardImageTypes, isShowRuleIsHide } from '../../atoms/BlurCard/BlurCard';
import { differenceInDays } from 'date-fns';
const EventBlock = _ref => {
  let {
    event,
    curatorsCopy,
    lang,
    callback,
    analytics,
    multipleDates = '',
    hostLink,
    linksTarget,
    removeFavButton,
    widgetAnalytics,
    countryItems,
    themeValues,
    inSlider,
    isListing = false,
    userProfile
  } = _ref;
  const {
    eventsAnalytics,
    params
  } = analytics;
  const imgAlt = get(event, 'title');
  const imgSrc = injectImageResolution(`${pathJoin([getMediaHost(), event.image])}`, 340, 243);
  const curators = get(event, 'curators.curators');
  const eventIsBusiness = get(event, 'eventIsBusiness');
  const currentDate = (() => {
    const currentDate = new Date(new Date().getTime());
    currentDate.setUTCHours(0, 0, 0, 0);
    return currentDate;
  })();
  const numberOfDaysBeforeEventStart = event.datesRange ? differenceInDays(new Date(event.datesRange.from_formatted), currentDate) : "datesRange is not provided";
  const numberOfDaysBeforeEventEnd = event.datesRange ? differenceInDays(new Date(event.datesRange.to_formatted ? event.datesRange.to_formatted : event.datesRange.from_formatted), currentDate) : "datesRange is not provided";
  const eventStarted = event.datesRange && (differenceInDays(currentDate, new Date(event.datesRange.from_formatted)) >= 0 ? true : false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isShowRuleIsHide(event) ? /*#__PURE__*/React.createElement("div", {
    className: "events__item"
  }, /*#__PURE__*/React.createElement(BlurCard, {
    userProfile: userProfile,
    hint: event,
    lang: lang,
    cardType: EBlurCardImageTypes.event,
    hitAnalytics: eventsAnalytics,
    hitParams: params,
    reminderTheme: themeValues,
    countryItems: countryItems,
    hitInSlider: inSlider,
    showWithAnimation: true,
    isEventBlur: true
  })) : /*#__PURE__*/React.createElement("div", {
    className: "events__item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__image-wrap"
  }, event.image && /*#__PURE__*/React.createElement(RouterLink, {
    href: getListingItemURL(hostLink, event.urlSlug, event.url),
    openInSameTab: true,
    linksTarget: linksTarget,
    onClick: () => !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['bannerClickAnalytics'], params), event.englishTitle),
    title: imgAlt
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "events__image",
    src: imgSrc,
    alt: imgAlt
  })))), /*#__PURE__*/React.createElement("div", {
    className: "events__info"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(CuratorPicks, {
    curators: curators,
    copy: curatorsCopy,
    linksTarget: linksTarget,
    analytics: {
      eventsAnalytics,
      params,
      name: event.englishTitle
    }
  })), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.15
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__text-sight"
  }, event.category && event.category.join(', '))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.3
  }, /*#__PURE__*/React.createElement("a", {
    className: "events__item-title",
    target: linksTarget ? linksTarget : '_self',
    href: getListingItemURL(hostLink, event.urlSlug, event.url),
    onClick: () => !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['titleClickAnalytics'], params), event.englishTitle)
  }, event.title)), event.datesRange && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.4
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__date-item"
  }, event.eventNextAvailableDate ? ` ${multipleDates} ${convertDate(event.eventNextAvailableDate, '', lang)}` : ` ${event.datesRange}` && convertDate(event.datesRange.from_formatted, event.datesRange.from_formatted === event.datesRange.to_formatted ? '' : event.datesRange.to_formatted, lang))), /*#__PURE__*/React.createElement("div", {
    className: "events__push-bottom"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.6
  }, !eventIsBusiness && /*#__PURE__*/React.createElement(Reminder, {
    userProfile: userProfile,
    lang: lang,
    event: event,
    countryItems: countryItems,
    themeValues: themeValues,
    modeSlider: inSlider,
    eventsAnalytics: eventsAnalytics,
    params: params,
    numberOfDaysBeforeEventStart: numberOfDaysBeforeEventStart,
    numberOfDaysBeforeEventEnd: numberOfDaysBeforeEventEnd,
    eventStarted: eventStarted
  }))), !removeFavButton && /*#__PURE__*/React.createElement(FavouriteBtn, {
    callback: callback,
    itemId: event && event.objectID,
    componentPrimaryColor: 'var(--events-theme-background-color)',
    componentPrimaryColorActive: "var(--events-theme-background-active-color)",
    classes: 'events__fav-btn',
    analyticsClick: eventTitle => !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['addToFavAnalytics'], params), `${eventTitle}: ${event.englishTitle}`),
    isListing: isListing
  }))));
};
export default EventBlock;